export interface Achievement {
  id: string;
  name: string;
  description: string;
  category: 'task' | 'phase' | 'milestone';
}

export const ALL_ACHIEVEMENTS: Achievement[] = [
  // Ordered succession per current program scope (Foundation → Activation)
  {
    id: 'constitutional_scholar',
    name: '🎓 Constitutional Scholar',
    description: 'Completed understanding your constitution',
    category: 'task'
  },
  {
    id: 'foundation_complete',
    name: '🏆 Foundation Complete',
    description: 'Completed all Foundation phase tasks',
    category: 'phase'
  },
  {
    id: 'meeting_master',
    name: '📋 Meeting Master',
    description: 'Successfully established meeting rhythms and documentation procedures',
    category: 'task'
  },
  {
    id: 'stewardship_in_action',
    name: '🌟 Stewardship in Action',
    description: 'Transferred your first asset!',
    category: 'task'
  },
  {
    id: 'entity_manager',
    name: '🏢 Entity Manager',
    description: 'Successfully transferred a Single Member LLC to your UNA',
    category: 'task'
  },
  {
    id: 'property_steward',
    name: '🏘️ Property Steward',
    description: 'Successfully transferred real estate to your UNA',
    category: 'task'
  },
  {
    id: 'asset_guardian',
    name: '🚗 Asset Guardian',
    description: 'Successfully transferred a vehicle to your UNA',
    category: 'task'
  },
  {
    id: 'master_steward',
    name: '⭐ Master Steward',
    description: 'Completed all Operations phase asset transfers',
    category: 'phase'
  },
  {
    id: 'privacy_guardian',
    name: '🔒 Privacy Guardian',
    description: 'Implemented comprehensive privacy protocols',
    category: 'task'
  },
  {
    id: 'governance_master',
    name: '⚖️ Governance Master',
    description: 'Established ongoing governance rhythms',
    category: 'task'
  },
  {
    id: 'legacy_steward',
    name: '🌳 Legacy Steward',
    description: 'Planned multi-generational transition',
    category: 'task'
  },
  {
    id: 'operations_complete',
    name: '🎯 Operations Complete',
    description: 'Completed all Operations phase tasks',
    category: 'phase'
  },
  {
    id: 'ongoing_excellence',
    name: '✨ Ongoing Excellence',
    description: 'Established recurring governance and compliance rhythms',
    category: 'task'
  },
  {
    id: 'ongoing_management',
    name: '📊 Ongoing Management',
    description: 'Mastered continuous UNA operations and reporting',
    category: 'task'
  },
  {
    id: 'heritage_guardian',
    name: '🏛️ Heritage Guardian',
    description: 'Achieved multi-generational stewardship mastery - The Ultimate Achievement',
    category: 'milestone'
  }
];
